import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";
import { deleteAdminSuccess } from "../forAdmins/forAdmins";
import { deleteClientSuccess } from "../forCients/forClients";

export const setAccountId = (accountId) => {
  return {
    type: actionTypes.SET_ACCOUNT_ID,
    accountId,
  };
};

export const fetchAccountStart = () => {
  return {
    type: actionTypes.FETCH_ACCOUNT_START,
  };
};
export const fetchAccountSuccess = (data) => {
  return {
    type: actionTypes.FETCH_ACCOUNT_SUCCESS,
    data,
  };
};
export const fetchAccountFail = (error) => {
  return {
    type: actionTypes.FETCH_ACCOUNT_FAIL,
    error,
  };
};

export const fetchAccountAdmin = (accountId) => {
  return (dispatch) => {
    // console.log(accountId);
    dispatch(fetchAccountStart());
    axios
      .get(`admin/client/${accountId}`)
      .then((res) => {
        // console.log(res.data.client);
        dispatch(fetchAccountSuccess(res.data.client));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchAccountFail(err.response.data.message));
        } else {
          dispatch(fetchAccountFail("Something went wrong"));
        }
      });
  };
};

export const fetchAccountSuper = (accountId) => {
  return (dispatch) => {
    // console.log(accountId);
    dispatch(fetchAccountStart());
    axios
      .get(`api/v1/super/user/profile/${accountId}`)
      .then((res) => {
        // console.log(res);
        dispatch(fetchAccountSuccess(res.data.userData));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchAccountFail(err.response.data.message));
        } else {
          dispatch(fetchAccountFail("Something went wrong"));
        }
      });
  };
};

// update Account
export const updateAccountStart = () => {
  return {
    type: actionTypes.UPDATE_ACCOUNT_START,
  };
};

export const updateAccountSuccess = (msg) => {
  return {
    type: actionTypes.UPDATE_ACCOUNT_SUCCESS,
    msg,
  };
};

export const updateAccountFail = (error) => {
  return {
    type: actionTypes.UPDATE_ACCOUNT_FAIL,
    error,
  };
};

export const updateAccountAdmin = (accountId, data) => {
  return (dispatch) => {
    // console.log(data);
    dispatch(updateAccountStart());
    axios
      .patch(`api/v1/admin/client/profile/${accountId}`, data)
      .then((res) => {
        // console.log(res);
        dispatch(updateAccountSuccess("ACCOUNT UPDATED"));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(updateAccountFail(err.response.data.message));
        } else {
          dispatch(updateAccountFail("Something went wrong"));
        }
      });
  };
};
export const updateAccountSuperAdmin = (accountId, data) => {
  return (dispatch) => {
    // console.log(data);
    dispatch(updateAccountStart());
    axios
      .patch(`api/v1/super/user/profile/${accountId}`, data)
      .then((res) => {
        // console.log(res);
        dispatch(updateAccountSuccess("ACCOUNT UPDATED"));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(updateAccountFail(err.response.data.message));
        } else {
          dispatch(updateAccountFail("Something went wrong"));
        }
      });
  };
};

// DELETE account
export const deleteAccountStart = () => {
  return {
    type: actionTypes.DELELTE_ACCOUNT_START,
  };
};

export const deleteAccountSuccess = (msg) => {
  return {
    type: actionTypes.DELELTE_ACCOUNT_SUCCESS,
    msg,
  };
};

export const deleteAccountFail = (error) => {
  return {
    type: actionTypes.DELELTE_ACCOUNT_FAIL,
    error,
  };
};

export const deleteAccount = (accountId, type) => {
  return (dispatch) => {
    dispatch(deleteAccountStart());
    // console.log(accountId);
    axios
      .delete(`api/v1/super/user/${accountId}`)
      .then((res) => {
        // console.log(res);
        if (type === "client") {
          dispatch(deleteClientSuccess(accountId));
        }
        if (type === "admin") {
          dispatch(deleteAdminSuccess(accountId));
        }
        dispatch(deleteAccountSuccess("ACCOUNT DELETED"));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(deleteAccountFail(err.response.data.message));
        } else {
          dispatch(deleteAccountFail("Something went wrong"));
        }
      });
  };
};

export const clearAccountMsg = () => {
  return {
    type: actionTypes.CLEAR_ACCOUNT_MSG,
  };
};
